import { Check } from 'lucide-react';
import type { StepsModel } from '@/models/ui/steps';

interface LeadWorkflowStepperProps {
  readonly stepsModel: StepsModel;
}

export function LeadWorkflowStepper({ stepsModel }: LeadWorkflowStepperProps) {
  const { steps } = stepsModel;

  return (
    <div className="mb-6">
      <ol
        start={1}
        aria-label="LeadWorkflowStepper"
        className="flex items-start justify-between w-2/3 mx-auto"
      >
        {steps.map((stepState, index) => {
          return (
            <li
              key={stepState.step.label}
              value={stepState.step.order}
              aria-current={
                stepState.step === stepsModel.currentStep ? 'step' : undefined
              }
              className="flex items-start flex-1 first:flex-none"
            >
              {index > 0 && (
                <div
                  className={`h-0.5 flex-1 mt-3 ${
                    stepState.completed ? 'bg-workflow-green' : 'bg-gray-300'
                  }`}
                ></div>
              )}
              <div className="flex flex-col items-center w-6 flex-none">
                <div
                  className={`w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all ${
                    stepState.completed
                      ? 'bg-workflow-green border-workflow-green'
                      : 'bg-gray-200 border-gray-300'
                  }`}
                >
                  {stepState.completed ? (
                    <Check className="w-4 h-4 text-white" />
                  ) : (
                    <div className="w-2 h-2 rounded-full bg-gray-400"></div>
                  )}
                </div>
                <span
                  className={`text-xs mt-2 font-medium whitespace-nowrap ${
                    stepState.completed ? 'text-black' : 'text-gray-400'
                  }`}
                >
                  {stepState.step.label}
                </span>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
